export const classicmetallics = {
  name: 'Classic Metallics',
  color: [0.9568627450980393, 0.9568627450980393, 0.9372549019607843, 1],
  bg: [0.03137254901960784, 0.027450980392156862, 0.023529411764705882, 1],
  grid1: [0.8196078431372549, 0.6980392156862745, 0.5019607843137255, 1],
  grid2: [0.34901960784313724, 0.30196078431372547, 0.27450980392156865, 1],
}
